import { Controller } from "@hotwired/stimulus"

// gtag.js verwacht een arguments-object in de dataLayer, geen array.
function gtag() { window.dataLayer.push(arguments) }

// Cookie Consent Controller
// Handles granular cookie consent: functional (always), analytics, marketing.
// Sets cookie_consent cookie with accepted categories.
// Dispatches 'cookie-consent-updated' event for script loaders.
// Met autoload (element zonder banner) laadt hij de eerder gegeven toestemming opnieuw.
export default class extends Controller {
  static targets = ["options", "analytics", "marketing"]
  static values = { autoload: Boolean }

  connect() {
    if (this.autoloadValue) this.loadStoredConsent()
  }

  loadStoredConsent() {
    if (window.consentDefaultsSet) return

    const stored = document.cookie.split(";").map(c => c.trim()).find(c => c.startsWith("cookie_consent="))
    if (!stored) return

    window.consentDefaultsSet = true
    window.dataLayer = window.dataLayer || []
    window.gtag = gtag
    gtag("consent", "default", {
      analytics_storage: "denied",
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied"
    })
    this.loadConsentedScripts(stored.split("=")[1])
  }

  acceptAll() {
    this.save("functional,analytics,marketing")
  }

  acceptNecessary() {
    this.save("functional")
  }

  toggleOptions() {
    this.optionsTarget.classList.toggle("hidden")
  }

  savePreferences() {
    const categories = ["functional"]
    if (this.analyticsTarget.checked) categories.push("analytics")
    if (this.marketingTarget.checked) categories.push("marketing")
    this.save(categories.join(","))
  }

  save(value) {
    const maxAge = 365 * 24 * 60 * 60
    document.cookie = `cookie_consent=${value}; path=/; max-age=${maxAge}; SameSite=Lax`
    this.dismiss()
    window.dispatchEvent(new CustomEvent("cookie-consent-updated", { detail: { consent: value } }))
    this.loadConsentedScripts(value)
  }

  dismiss() {
    this.element.remove()
  }

  loadConsentedScripts(consent) {
    const categories = consent.split(",")
    if (categories.includes("analytics")) this.loadAnalytics()
    if (categories.includes("marketing")) this.loadMarketing()
  }

  loadAnalytics() {
    if (window.gtagLoaded) return
    window.gtagLoaded = true

    window.dataLayer = window.dataLayer || []
    window.gtag = gtag
    gtag("consent", "update", { analytics_storage: "granted" })
    gtag("js", new Date())
    gtag("config", "G-WM6BLK4CLF")

    const script = document.createElement("script")
    script.async = true
    script.src = "https://www.googletagmanager.com/gtag/js?id=G-WM6BLK4CLF"
    document.head.appendChild(script)
  }

  loadMarketing() {
    if (window.linkedinLoaded) return
    window.linkedinLoaded = true

    window._linkedin_partner_id = "8879962"
    window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || []
    window._linkedin_data_partner_ids.push("8879962")

    const script = document.createElement("script")
    script.type = "text/javascript"
    script.async = true
    script.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js"
    document.head.appendChild(script)
  }
}
